export default __webpack_public_path__ + "static/media/buble-discussion-104.7f90589c.svg";